import Service from '../../services'
import { checkAndReturn } from "../../main"

const state = {
    GeneralForm: {},
    BusinessForm: {},
    IssuesAndNeedsForm: {}
}

const getters = {

}

const actions = {
    getExtendForms ({ commit }, params) {
        return Service.Extend.getExtendForms(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    getExtendFormById ({ commit }, params) {
        return Service.Extend.getExtendFormById(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    createExtendForm ({ commit }, data) {
        return Service.Extend.createExtendForm(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    saveExtendForm ({ commit }, data) {
        return Service.Extend.saveExtendForm(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    editExtendForm ({ commit }, data) {
        return Service.Extend.editExtendForm(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    updateExtendForm ({ commit }, data) {
        return Service.Extend.updateExtendForm(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    }
}

const mutations = {
    setGeneralForm (state, val) {
        state.GeneralForm = val
    },

    setBusinessForm (state, val) {
        state.BusinessForm = val
    },

    setIssuesAndNeedsForm (state, val) {
        state.IssuesAndNeedsForm = val
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
